/* script */































































import Vue from 'vue';
import Component from 'vue-class-component';

type Image = {
    id: number;
    name: Translation;
    filepath: string;
};

@Component({
    props: ['hasArrowButton', 'images', 'clickable', 'lang'],
})
class GratuityCarouselComponent extends Vue {
    hasArrowButton!: boolean;
    clickable!: boolean;
    images!: Image[];
    imageIndex: number = 0;
    lang!: string;
    timerId!: number;
    currentIndex: number = 0;

    setTimer() {
        this.timerId = window.setInterval(() => {
            if (this.imageIndex + 1 === this.images.length) {
                this.imageIndex = 0;
                this.slidePulas();
                return;
            } else {
                this.imageIndex += 1;
                this.slidePulas();
            }
        }, 6000);
    }

    resetTimer() {
        clearInterval(this.timerId);
        this.setTimer();
    }

    created() {
        if (!this.images) return;
        if (this.images.length === 1) return;
        this.setTimer();
    }

    beforeDestroy() {
        clearInterval(this.timerId);
    }

    slidePulas() {
        for (let img of document.getElementsByClassName(
            'carousel__item'
        ) as HTMLCollectionOf<HTMLElement>) {
            let percent = this.imageIndex * img.clientWidth;
            this.currentIndex = this.imageIndex;
            img.style.transform =
                this.imageIndex > 0
                    ? 'translateX(-' + percent + 'px)'
                    : 'translateX(0)';
        }
    }

    changeDisplayingImage(operand: -1 | 1): void {
        if (this.imageIndex + operand === this.images.length) {
            this.imageIndex = 0;
            this.slidePulas();
            return;
        }
        if (this.imageIndex + operand < 0) {
            this.imageIndex = this.images.length - 1;
            this.slidePulas();
            return;
        }
        this.imageIndex += operand;
        this.slidePulas();
        this.resetTimer();
    }

    jumpDisplayingImage(index: number): void {
        this.imageIndex = index;
        this.slidePulas();
        this.resetTimer();
    }

    setGratuityStaff(image: Image) {
        if (!this.clickable) return;
        this.$emit('setGratuityStaff', image.id);
    }
}
const __vue_script__ = GratuityCarouselComponent;

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "gratuity-carousel" } },
    [
      _vm.hasArrowButton
        ? [
            _c("div", { staticClass: "arrow_carousel" }, [
              _c("span", {
                staticClass: "arrow_button",
                attrs: { "before-icon": "chevron_left" },
                on: {
                  click: function ($event) {
                    return _vm.changeDisplayingImage(-1)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "carousel" },
                _vm._l(_vm.images, function (image, key) {
                  return _c(
                    "div",
                    { key: key, staticClass: "carousel__item" },
                    [
                      _c("div", {
                        key: key,
                        staticClass: "gratuity_img",
                        style: {
                          backgroundImage: "url(" + image.filepath + ")",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setGratuityStaff(image)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "gratuity_text" }, [
                        _vm._v(_vm._s(image.name[_vm.lang])),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "arrow_button",
                attrs: { "before-icon": "chevron_right" },
                on: {
                  click: function ($event) {
                    return _vm.changeDisplayingImage(1)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "carousel__indicator__container" },
              _vm._l(_vm.images, function (image, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "carousel__indicator" },
                  [
                    index === _vm.currentIndex
                      ? _c(
                          "div",
                          { staticClass: "carousel__indicator--active" },
                          [
                            _vm._v(
                              "\n                    ⚫︎\n                "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.jumpDisplayingImage(index)
                              },
                            },
                          },
                          [_vm._v("⚪︎")]
                        ),
                  ]
                )
              }),
              0
            ),
          ]
        : _c(
            "div",
            { staticClass: "carousel large" },
            _vm._l(_vm.images, function (image, key) {
              return _c("div", {
                key: key,
                staticClass: "carousel__item",
                style: { backgroundImage: "url(" + image.filepath + ")" },
              })
            }),
            0
          ),
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "script_src/common/gratuity/GratuityCarousel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__